import React from 'react';
import {Modal,Paper,Button,CircularProgress } from '@material-ui/core';
import styled from 'styled-components';
import ProjectLookup from '../projectLookup/ProjectLookup';
import ProjectsContext from './ProjectsContext';


const Container = styled.div`

    display:flex;
    align-items:center;
    justify-content:center;

`;

const PaperContainer = styled.div`

    display:flex;
    padding-left:40px;
    height:340px;
    width:700px;
    justify-content:space-around;
    flex-direction:column;

`;

const Title = styled.div`
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
`;


const BottomButtonsContainer = styled.div`

    display:flex;
    width:200px;
    align-items:flex-start;
    justify-content:space-between;

`;

class ProjectAddModal extends React.Component {

    static contextType = ProjectsContext;
    
    constructor(props)
    {
        super(props);
        this.state = {projectToAdd:null};
    }

    render()
    {   
        return <ProjectsContext.Consumer>{context=> this.renderContent(context)}</ProjectsContext.Consumer>

    }

    renderContent(context) {
        const loading = false;
     return(
         <>
         {context.addingProjectDialogOpen &&
            <Modal open={true} >
               <Container style={{height:window.innerHeight}}>
                        <Paper>
                            <PaperContainer>
                                <Title>Add Project</Title>

                                {!loading &&
                                    <React.Fragment>
                                        <ProjectLookup onProjectSelected={projectToAdd=>this.setState({projectToAdd})} selectedProject={this.state.projectToAdd}/>
                                        <BottomButtonsContainer>
                                            <Button 
                                                variant="outlined" 
                                                color="primary" 
                                                onClick={() => { 
                                                    context.closeAddProjectDialog(false);
                                                    this.setState({projectToAdd:null});
                                                }}>
                                                Cancel
                                            </Button>
                                            <Button variant="outlined"
                                                    disabled={!this.state.projectToAdd}
                                                    color="primary" 
                                                    onClick={() => {
                                                        context.addProject(this.state.projectToAdd);
                                                        this.setState({projectToAdd:null});
                                                        context.closeAddProjectDialog(false);

                                                    
                                                    }}  >
                                                Add
                                            </Button>
                                        </BottomButtonsContainer>
                                    </React.Fragment>
                                }
                                {!!loading &&
                                    <CircularProgress/>
                                }
                                
                            </PaperContainer>
                        </Paper>
                </Container>       
            </Modal>
         }
            </>
  
      )
    }
}

export default ProjectAddModal;